module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Lig.b53a9b98.woff";